import React from "react";
import ReactQuill from "react-quill";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import { IPharmaInventoryCreate } from "src/types/GlobalInterfaces";

interface IProps {
  state: IPharmaInventoryCreate;
  setState: (key: keyof IPharmaInventoryCreate, val: string) => void;
  tabChange: () => void;
}

const InventryOverviewTab: React.FC<IProps> = ({
  state,
  setState,
  tabChange,
}) => {
  return (
    <>
      <div className="products-tabs-content pharma__inventory__overview">
        <div className="mt-2">
          <h2 className="font-size-24px font-Poppins-Bold">Overview</h2>
          <ReactQuill
            theme="snow"
            style={{ backgroundColor: "#fff" }}
            value={state?.overview}
            onChange={(txt: string) => setState("overview", txt)}
            id="overview-input"
          />
        </div>
        <div className="mt-6">
          <h2 className="font-size-24px font-Poppins-Bold">Product Details</h2>
          <ReactQuill
            theme="snow"
            style={{ backgroundColor: "#fff" }}
            value={state?.productDetails}
            onChange={(txt: string) => setState("productDetails", txt)}
            id="product-details-input"
          />
        </div>
      </div>
      <div className="flex justify-end my-6">
        <PrimaryBtn
          ButtonText="Next"
          btnExtraStyle={{ backgroundColor: "#00443f", borderRadius: "1.5rem" }}
          onPress={tabChange}
          id="next-btn"
        />
      </div>
    </>
  );
};

export default InventryOverviewTab;
